import { render } from "./SectionAboutWelcomeOrganization.vue?vue&type=template&id=06b0cff4&scoped=true"
import script from "./SectionAboutWelcomeOrganization.vue?vue&type=script&lang=js"
export * from "./SectionAboutWelcomeOrganization.vue?vue&type=script&lang=js"

import "./SectionAboutWelcomeOrganization.vue?vue&type=style&index=0&id=06b0cff4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b0cff4"]])

export default __exports__